const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
export const getSelectI18nOption = namespaceI18n => props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    t
  } = useTranslation(namespaceI18n);
  return /*#__PURE__*/React.createElement(components.Option, rest, t(props.data.label));
};
export const getSelectI18nSingleValue = namespaceI18n => props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const {
    t
  } = useTranslation(namespaceI18n);
  return /*#__PURE__*/React.createElement(components.SingleValue, rest, t(props.data.label));
};
export const getSelectI18nMultiOption = namespaceI18n => props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const {
    t
  } = useTranslation(namespaceI18n);
  return /*#__PURE__*/React.createElement(components.Option, rest, t(props.data.label));
};
export const getSelectI18nMultiValueLabel = namespaceI18n => props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  const {
    t
  } = useTranslation(namespaceI18n);
  return /*#__PURE__*/React.createElement(components.MultiValueLabel, rest, t(props.data.label));
};
export const getSelectI18nComponents = namespaceI18n => ({
  Option: getSelectI18nOption(namespaceI18n),
  SingleValue: getSelectI18nSingleValue(namespaceI18n)
});
export const getSelectI18nMultiComponents = namespaceI18n => ({
  Option: getSelectI18nMultiOption(namespaceI18n),
  MultiValueLabel: getSelectI18nMultiValueLabel(namespaceI18n)
});